<mat-card ngClass="{{ cssClasses.card }}" class="card-wrapper"
  [ngStyle]="{ 'flex-direction': cssClasses.cardFlexDirection }">
  @if (cssClasses.showImage) {
  <div ngClass="{{ cssClasses.leftside }}" class="flex-col flex-justify-center flex-align-center detail-wrapper"
    [ngStyle]="{
			'max-width':
				cssClasses.cardFlexDirection === 'row' ? cssClasses.imageFxFlex + '%' : 'inherit',
			'max-height':
				cssClasses.cardFlexDirection === 'column' ? cssClasses.imageFxFlex + '%' : 'inherit'
		}">
    <a routerLink="{{ content().permalink }}">
      <img [ngClass]="cssClasses.img" src="{{ content().pathFoto }}" />
    </a>
    <div class="detail-container">
      <ng-content select="[detail_container]"></ng-content>
    </div>
  </div>
  }
  <div class="flex-col flex-justify-start card-content-wrapper">
    <mat-card-title-group>
      <mat-card-title [ngClass]="cssClasses.title">
        <h2>
          @if (content().premium) {
          <img class="icona-premium" src="assets/premium.png" /> }@if (content().template === 'articolo-riservato') {
          <mat-icon>https</mat-icon> }<a routerLink="{{ content().permalink }}">
            {{ content().titolo }}</a>
        </h2>
      </mat-card-title>
      @if ( ![ContentVisualizationType.OnlyTitleCard, ContentVisualizationType.RubricaCard].includes(
      visualizationType() ) ) {
      <mat-card-subtitle [ngClass]="cssClasses.subtitle">
        <a href="topic/{{ content().descrizioneTopic | urlClean }} ">{{ content().descrizioneTopic }} </a>| {{
        content().autore }} | {{ content().dataCreazione | date : 'dd/MM/yyyy HH:mm' : 'UTC' }}</mat-card-subtitle>
      }
    </mat-card-title-group>
    <div class="detail-container-mobile">
      <ng-content select="[detail_container_mobile]"></ng-content>
    </div>
    @if ( ![ ContentVisualizationType.OnlyTitleCard, ContentVisualizationType.VideoCardDxColumn,
    ContentVisualizationType.RubricaCard ].includes(visualizationType()) ) {
    <mat-card-content>
      <div [ngClass]="cssClasses.eyelet" class="flex-col">
        <p>
          {{ content().occhiello }}
        </p>
      </div>
      <div [ngClass]="cssClasses.actionDiv" class="flex-row flex-justify-space-between flex-align-center">
        @if (buttonAction() && cssClasses.showAction) {
        <a class="button-anchor" routerLink="{{
						content().idMinisito > 0
							? '/' + content().tipoContesto + '/' + content().idMinisito + content().permalink
							: content().permalink
					}}" [ngClass]="cssClasses.action" mat-raised-button color="accent">
          {{ buttonAction() }}
        </a> }
        <ng-content class="flex-row-50" select="[detail]"></ng-content>
      </div>
    </mat-card-content>
    }
  </div>
</mat-card>